import React from "react";
import lodash from "lodash";
import PATHS from "config/paths";

/* eslint-disable react-hooks/exhaustive-deps */

export function useDeleteSocial(token, requestSocial, isConfirmed) {
  const [response, setResponse] = React.useState();
  const [error, setError] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [social, setSocial] = React.useState();


  /**
   * Compare requestBody to social so we don't infinite loop
   */
  React.useEffect(() => {
    if (!lodash.isEqual(requestSocial, social) &&  isConfirmed) {
      setError(undefined);
      setResponse(undefined);
      setSocial(requestSocial);
      setIsLoading(true);
    }
  }, [requestSocial, setSocial,  isConfirmed]);

  /**
   * Make Request
   */
  React.useEffect(() => {
    if (token && social ) {
      const options = {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      };

      const path = `${PATHS.apiSocials}/${social.id}`;

      async function postRequest() {
        const request = await fetch(path, options);
        return true;
      }

      // Delete returns 204 No Content so it does not have a body, setResponse to true
      postRequest()
        .then(async (response) => {      
           setResponse(response)
          })
          .catch((err) => {
            setError(err);
          })
          .finally(() => {
            setIsLoading(false);
          });
    }
  }, [token, social, setResponse]);

  return { socialDeleteSuccess: response, socialDeleteError: error, socialIsLoading: isLoading };
}
